// extracted by mini-css-extract-plugin
module.exports = {"label":"DateField-label-f97a8438e39bfbc68cdaaf0baf5a71da","date":"DateField-date-8e0f97f01a4f6b155c4e160e5601b357"};